module.exports = __webpack_public_path__ + "img/logo_gmail_32px.4b34ab14.svg";